import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from 'react';
import { element, string, oneOfType, arrayOf, node } from 'prop-types';
import Box from '../Box';
import { getPanelId, getTabId, useTabContext } from '../TabContext';
const TabPanel = /*#__PURE__*/React.forwardRef(function TabPanel(_ref, ref) {
  let {
    children,
    value
  } = _ref,
      other = _objectWithoutPropertiesLoose(_ref, ["children", "value"]);

  const context = useTabContext();

  if (context === null) {
    throw new TypeError('No TabContext provided');
  }

  const id = getPanelId(context, value);
  const tabId = getTabId(context, value);
  if (value === undefined) return null;
  return /*#__PURE__*/React.createElement(Box, _extends({
    ref: ref,
    hidden: context.value !== value,
    id: id,
    "aria-labelledby": tabId,
    role: "tabpanel"
  }, other), children);
});
process.env.NODE_ENV !== "production" ? TabPanel.propTypes = {
  children: oneOfType([element, string, arrayOf(element), node]),
  value: string
} : void 0;
export default TabPanel;